import * as Sentry from '@sentry/capacitor';
import axios, { AxiosError, AxiosInstance } from 'axios';

import {
	buildUnauthorizedContext,
	unauthorizedError$,
} from '@mopla/business-logic';

const instance = axios.create({
	headers: {
		//Accept: 'application/json',
	},
});

let isHandling401 = false;

const handle401UnauthorizedError = async (error: AxiosError): Promise<void> => {
	// Prevent multiple simultaneous logout attempts
	if (isHandling401) {
		return;
	}

	isHandling401 = true;

	try {
		// Emit the request context to trigger the 401 handling effect
		unauthorizedError$.next(buildUnauthorizedContext(error));
	} catch (emitError) {
		console.error('[Auth] Failed to emit unauthorized event:', emitError);
		Sentry.captureException(emitError);
	} finally {
		// Reset flag after a delay to allow for potential retries
		setTimeout(() => {
			isHandling401 = false;
		}, 1000);
	}
};

/**
 * 401 interceptor to handle unauthorized errors (e.g., after password reset)
 */
instance.interceptors.response.use(
	(response) => response,
	async (error: AxiosError) => {
		if (error.response?.status === 401) {
			await handle401UnauthorizedError(error);
		}
		return Promise.reject(error);
	}
);

export const axiosInstance: AxiosInstance = instance;
